<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-row>
        <v-col cols="2">
          <v-icon @click="goBack">
            mdi-chevron-left
          </v-icon>
        </v-col>
        <v-col class="d-flex justify-space-around">
          <v-toolbar-title class="pageTitle">
            Pfandrückgabe
          </v-toolbar-title>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider class="headerDivider"/>

    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
      <v-btn @click="generateLabels">
        <span>Label erstellen</span>
        <i class="my-icon customIcon"></i>
      </v-btn>

      <v-card class="depositListCard" v-if="!isLoading">
        <v-container class="depositListContainer">
          <table>
            <thead>
            <td>
              <b>Artikel</b>
            </td>

            <td>
              <b>Preis</b>
            </td>
            </thead>
            <tbody >
            <tr v-for="item in labelItems"
                :key="item.itemNo">
              <td>
                    <span>
                      {{ item.description}}
                      <br>
                      {{ item.itemNo}}
                    </span>
              </td>
              <td>
                <v-text-field class="searchCbx depositListInput"
                              rounded
                              dense
                              outlined
                              suffix="€"
                              :v-model="item.price"
                              :value="labelItems === null ? '' : parsePriceToLocale(item.price)"
                              @blur="updateLabelPrice(item.itemNo, $event.target.value)"
                >

                </v-text-field>
              </td>
            </tr>
            </tbody>
          </table>
        </v-container>
      </v-card>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'
import router from "@/router";
export default {
  name: "labels",

  components: {

  },

  data() {
    return {
      labelItems: null,
      isLoading: true
    }
  },

  methods: {
    ...mapActions({
      getLabelFile: 'getLabelFile',
      getCurrentLabels: 'getCurrentLabels',
      updateLabel: 'updateLabel'
    }),

    ...mapMutations({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    goBack() {
      router.go(-1)
    },

    generateLabels() {
      this.getLabelFile()
    },

    parsePriceToLocale(price) {
      return parseFloat(price).toLocaleString('de', {maximumFractionDigits: 2, minimumFractionDigits: 2})
    },

    updateLabelPrice(item, price) {
        price = price.replace(',', '.')
        price = parseFloat(price).toLocaleString('en', {maximumFractionDigits: 2, minimumFractionDigits: 2})

        console.log(price)


        let params = {
          artNr: item,
          price: price
        }

      this.labelItems.forEach((el) => {
          if(el.itemNo === item) {
            el.price = price
          }
      })

      this.updateLabel(params).then(() => {

      })
    }
  },

  computed: {

  },

  mounted() {
    this.setHeaderVisibility(false)
    this.getCurrentLabels().then(resp => {
      this.labelItems = resp
      this.isLoading = false
    })

  }
}
</script>

<style>
  .my-icon::before, .my-icon::after {
    font-family: "Font Awesome 5 Free";
  }

  .my-icon.customIcon::before {
    content: '\f0e0';
  }
</style>
